import React from "react";

// Safe fallbacks to prevent "ReferenceError" if your custom animation variables/hooks are globally defined or missing
const safeUseReveal = () => {
  try {
    // @ts-ignore
    if (typeof useReveal === "function") return useReveal();
  } catch (e) {}
  return null;
};

const safeHide = (direction) => {
  try {
    // @ts-ignore
    if (typeof hide === "function") return hide(direction);
  } catch (e) {}
  return {};
};

export default function PresidentMessage() {
  const ref = safeUseReveal();

  return (
    <section
      id="president-message"
      className="bg-white pt-32 pb-24 lg:pt-40 lg:pb-32 font-sans border-b border-gray-100"
    >
      <div
        ref={ref}
        className="w-full max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16 xl:px-24"
      >
        {/* Centered Heading Title Block */}
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-24">
          <h2
            data-r
            className="text-4xl md:text-5xl font-extrabold text-[#0F1C35] tracking-tight"
            style={safeHide("up")}
          >
            President Message
          </h2>
          
        </div>

        {/* Editorial Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          
          {/* Left Column: Premium Minimalist Profile Panel */}
          <div 
            data-r
            style={safeHide("up")}
            className="lg:col-span-4 flex flex-col items-center lg:items-start text-center lg:text-left sticky top-32"
          >
            <div className="w-full max-w-[280px] sm:max-w-[320px] lg:max-w-full aspect-[4/5] rounded-2xl overflow-hidden shadow-md border border-gray-100 mb-6 bg-gray-50">
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/b/bc/Unknown_person.jpg?utm_source=commons.wikimedia.org&utm_campaign=index&utm_content=original" 
                alt="President, BICCI" 
                className="w-full h-full object-cover"
              />
            </div>
            {/* <h3 className="text-xl font-bold text-[#0F1C35]">
              John Doe
            </h3> */}
            <p className="text-[#0077b6] text-sm font-semibold mt-1 uppercase tracking-wider">
              President, BICCI
            </p>
          </div>

          {/* Right Column: Clean Correspondence Content */}
          <div 
            data-r
            style={safeHide("up")}
            className="lg:col-span-8 space-y-6 text-[#3D4A62] text-base md:text-lg leading-relaxed font-normal"
          >
            {/* Elegant Callout Message Fragment */}
            <div className="border-l-4 border-[#0077b6] pl-6 py-2 mb-8 bg-[#F8F9FA] rounded-r-xl">
              <p className="text-lg md:text-xl font-medium text-[#0F1C35] italic">
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed bibendum tellus et velit laoreet, ac porta tortor lobortis. Integer interdum feugiat pretium. Nullam consequat enim justo, eu volutpat ante aliquam."
              </p>
            </div>

            <p className="text-[17px] md:text-xl font-semibold text-[#0F1C35] leading-snug">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed bibendum tellus et velit laoreet, ac porta tortor lobortis. Integer interdum feugiat pretium. Nullam consequat enim justo, eu volutpat ante aliquam.
            </p>
            
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed bibendum tellus et velit laoreet, ac porta tortor lobortis. Integer interdum feugiat pretium. Nullam consequat enim justo, eu volutpat ante aliquam.
            </p>
            
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed bibendum tellus et velit laoreet, ac porta tortor lobortis. Integer interdum feugiat pretium. Nullam consequat enim justo, eu volutpat ante aliquam.
            </p>
            
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed bibendum tellus et velit laoreet, ac porta tortor lobortis. Integer interdum feugiat pretium. Nullam consequat enim justo, eu volutpat ante aliquam.
            </p>
            
            {/* Professional Sign-off */}
            <div className="pt-8 mt-8 border-t border-gray-100">
              {/* <p className="font-bold text-[#0F1C35] text-base">
                John Doe
              </p> */}
              <p className="text-xs md:text-sm text-gray-500 mt-0.5 uppercase tracking-wider font-medium">
                President, Bangladesh Italy Chamber of Commerce & Industry
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}